import { CheckCircle2Icon, MessageSquareIcon, TicketIcon, UserPlusIcon } from "lucide-react";

import { AccountActivityType } from "@/features/account/types";

/**
 * Maps the activity discriminators returned by GET /users/me/overview onto the
 * union used throughout the account feature.
 */
export const ACTIVITY_TYPE_FROM_API: Record<string, AccountActivityType> = {
  ticket_created: "TicketCreated",
  ticket_resolved: "TicketResolved",
  ticket_assigned: "TicketAssigned",
  comment_added: "CommentAdded",
  project_joined: "ProjectJoined",
};

export const ACTIVITY_TYPE_CONFIG: Record<AccountActivityType, { icon: React.ElementType; iconClass: string; bgClass: string; label: string }> = {
  TicketCreated: {
    icon: TicketIcon,
    iconClass: "text-primary",
    bgClass: "bg-primary/10",
    label: "Ticket created",
  },
  TicketResolved: {
    icon: CheckCircle2Icon,
    iconClass: "text-emerald-600 dark:text-emerald-400",
    bgClass: "bg-emerald-500/10",
    label: "Ticket resolved",
  },
  TicketAssigned: {
    icon: TicketIcon,
    iconClass: "text-amber-600 dark:text-amber-400",
    bgClass: "bg-amber-500/10",
    label: "Ticket assigned",
  },
  CommentAdded: {
    icon: MessageSquareIcon,
    iconClass: "text-muted-foreground",
    bgClass: "bg-muted",
    label: "Comment added",
  },
  ProjectJoined: {
    icon: UserPlusIcon,
    iconClass: "text-primary",
    bgClass: "bg-primary/10",
    label: "Joined project",
  },
};

/**
 * Mirrors the rules enforced by `updatePasswordSchema`. Rendered as a live
 * checklist while the user types a new password.
 */
export const PASSWORD_REQUIREMENTS: { label: string; test: (value: string) => boolean }[] = [
  { label: "At least 8 characters", test: (value) => value.length >= 8 },
  { label: "An uppercase letter", test: (value) => /[A-Z]/.test(value) },
  { label: "A lowercase letter", test: (value) => /[a-z]/.test(value) },
  { label: "A number", test: (value) => /[0-9]/.test(value) },
  { label: "A special character", test: (value) => /[^A-Za-z0-9]/.test(value) },
];
